import * as React from 'react';
import { isDefined } from '@grandvisionhq/utils';
import '../../../../../context/actions.js';
import '../../../../../context/reducer.js';
import { useProductData } from '../../../../../context/product-context-hooks.js';
import '../../../../../context/ProductContext.js';
import '../../../../../context/CmsContext.js';
import { ProductAnalyticsEvents } from '../../../../Analytics/events/ProductAnalyticsEvents.js';
import { useEcommFacetContext } from '../../../context/EcommFacetContext.js';
import '@grandvisionhq/iris-ui';
import '@grandvisionhq/inventory';
import '@grandvisionhq/state';
import 'classnames';
import '@grandvisionhq/common';
import '@grandvisionhq/elements';
import '@grandvisionhq/frk-routing';
import '@grandvisionhq/analytics';
import '../../../../../types/product.js';
import '../../../../VTO/context/VtoProvider.js';
import '@swc/helpers';
import 'usehooks-ts';
import '@grandvisionhq/icons';
import { FacetPickerOther } from '../../FacetPickers/FacetPickerOther/FacetPickerOther.js';
import { SingleFacetTerm } from '../components/SingleFacetTerm.js';

const SingleFacetPicker = ({ className , hideStockIndicator  })=>{
    const { activeVariant: { stock  } , product: { productType  } ,  } = useProductData();
    const { handleVariantSelection , facetPickerConfig: { activeParentFacet , colorFacets , otherFacets , showParentFacetPicker  } ,  } = useEcommFacetContext();
    const singleFacets = [
        ...otherFacets,
        ...colorFacets
    ];
    const showFacetPickerStock = isDefined(hideStockIndicator) ? !hideStockIndicator && stock.enableStockIndicator : stock.enableStockIndicator;
    const handleFacetSelection = (props)=>{
        const { name , sku , facetTerm  } = props;
        ProductAnalyticsEvents.pushPdpVariantClickEvent({
            type: productType,
            name,
            id: sku,
            dimension147: facetTerm
        });
        handleVariantSelection(props);
    };
    if (!singleFacets.length && hideStockIndicator) {
        // If there are no facets to show and the stock indicator is disabled, return null
        return null;
    }
    return /*#__PURE__*/ React.createElement(React.Fragment, null, !showParentFacetPicker && /*#__PURE__*/ React.createElement(SingleFacetTerm, {
        className: className,
        showStockIndicator: !hideStockIndicator
    }), singleFacets && showParentFacetPicker && /*#__PURE__*/ React.createElement(FacetPickerOther, {
        className: className,
        productType: productType,
        activeFacet: activeParentFacet,
        onPick: handleFacetSelection,
        items: singleFacets,
        enableStockIndicator: showFacetPickerStock
    }));
};

export { SingleFacetPicker };
//# sourceMappingURL=SingleFacetPicker.js.map
